import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { BillOfMaterialFieldComponent } from './bill-of-material-field.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  declarations: [
    BillOfMaterialFieldComponent,
  ],
  exports: [
    BillOfMaterialFieldComponent,
  ],
})
export class BillOfMaterialsExportModule {}
